import { combineReducers } from 'redux';
import types from './types';

const spaces = (state = [], action) => {
  switch (action.type) {
    case types.GET_SPACES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const assessment = (state = null, action) => {
  switch (action.type) {
    case types.RUN_ASSESSMENT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const assessments = (state = [], action) => {
  switch (action.type) {
    case types.GET_ASSESSMENTS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const hdpsFeatures = (state = {}, action) => {
  switch (action.type) {
    case types.GET_HDPS_FEATURES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const population = (state = [], action) => {
  switch (action.type) {
    case types.GET_POPULATION_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const staffRoi = (state = null, action) => {
  switch (action.type) {
    case types.SET_STAFF_ROI:
      return action.payload;
    default:
      return state;
  }
};

const patientRoi = (state = null, action) => {
  switch (action.type) {
    case types.SET_PATIENT_ROI:
      return action.payload;
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case types.GET_SPACES:
    case types.CREATE_SPACE:
    case types.RUN_ASSESSMENT:
    case types.SAVE_ASSESSMENT:
      return true;
    case types.GET_SPACES_SUCCESS:
    case types.GET_SPACES_FAILURE:
    case types.CREATE_SPACE_SUCCESS:
    case types.CREATE_SPACE_FAILURE:
    case types.RUN_ASSESSMENT_SUCCESS:
    case types.SAVE_ASSESSMENT_SUCCESS:
    case types.SAVE_ASSESSMENT_FAILURE:
      return false;
    default:
      return state;
  }
};

const reducer = combineReducers({
  spaces,
  assessment,
  assessments,
  hdpsFeatures,
  population,
  staffRoi,
  patientRoi,
  loading,
});

export default reducer;
